<template>
  <button @click="back" :disabled="disabled" type="button" class="btn btn-primary">
    <i class="fa fa-arrow-left fa-fw"></i>
  </button>
</template>
<script>
  import Ncs from 'ncs'

  export default {extends: Ncs.defaultComponents.NcsBackButton}
</script>